import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import Hls from 'hls.js'; // Import HLS.js
import { useResponsiveScreen } from "../../../../hooks/useResponsiveScreen";
/**
 * Video for the images preview in the details page of the product
 */
export const ImagesPreviewVideo = (props) => {
    const { id, src, poster, controls, classExtra } = props;
    const [isActive, setIsActive] = useState(false);
    const refVideo = useRef(null);
    const refIcon = useRef(null);
    const { isDesktop } = useResponsiveScreen();
    // Handle the touch click
    const handleTouchClick = () => {
        setIsActive(!isActive);
    };
    // Lazy load the video
    useEffect(() => {
        let hls;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const video = refVideo.current;
                if (entry.isIntersecting) {
                    refIcon.current && (refIcon.current.style.display = 'block');
                    if ((video === null || video === void 0 ? void 0 : video.dataset.hls) || !video)
                        return;
                    if (Hls.isSupported()) {
                        hls = new Hls();
                        hls.attachMedia(refVideo.current);
                        hls.loadSource(src);
                        //catrh error
                        hls.on(Hls.Events.ERROR, function (event, data) {
                            if (data.fatal) {
                                switch (data.type) {
                                    case Hls.ErrorTypes.NETWORK_ERROR:
                                        console.error("fatal network error encountered, try to recover");
                                        hls.startLoad();
                                        break;
                                    case Hls.ErrorTypes.MEDIA_ERROR:
                                        console.error("fatal media error encountered, try to recover");
                                        hls.recoverMediaError();
                                        break;
                                    default:
                                        console.error("fatal error encountered, try to recover");
                                        hls.startLoad();
                                        break;
                                }
                            }
                        });
                    }
                    else if (refVideo.current) {
                        refVideo.current.src = src;
                    }
                    if (!isDesktop)
                        refVideo.current.poster = poster;
                }
                else {
                    if (video)
                        video.src = '';
                    hls && hls.destroy();
                }
            });
        }, { threshold: 0.1 });
        refVideo.current && observer.observe(refVideo.current);
        return () => {
            refVideo.current && observer.unobserve(refVideo.current);
        };
    }, []);
    const playVideo = () => {
        const video = refVideo.current;
        const icon = refIcon.current;
        if (video) {
            video.controls = true;
            video.play();
        }
        else {
            console.error("Video element not found inside slick-active");
        }
        if (icon) {
            icon.style.display = 'none';
        }
    };
    return _jsxs("div", { className: 'div-images-videos ', id: `video-icon-slider-${id}`, children: [!classExtra && (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "35", height: "35", viewBox: "0 0 35 35", className: `svg-icon-slider_videos ${isActive ? 'touched_button_availability' : ''}`, ref: refIcon, onTouchStart: handleTouchClick, onTouchEnd: handleTouchClick, onClick: playVideo, children: _jsxs("g", { id: "Icon-PlayVideoWhite", className: "icon_PlayVideo_carousel", transform: "translate(-5 -4)", children: [_jsx("path", { id: "Path", d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z", transform: "translate(5 4)", opacity: "0.3" }), _jsxs("g", { id: "Path-2", "data-name": "Path", transform: "translate(5 4)", fill: "none", children: [_jsx("path", { d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z", stroke: "none" }), _jsx("path", { d: "M 17.5 2 C 13.35980033874512 2 9.467409133911133 3.612279891967773 6.539850234985352 6.539850234985352 C 3.612279891967773 9.467409133911133 2 13.35980033874512 2 17.5 C 2 21.64019966125488 3.612279891967773 25.53258895874023 6.539850234985352 28.46014976501465 C 9.467409133911133 31.38772010803223 13.35980033874512 33 17.5 33 C 21.64019966125488 33 25.53258895874023 31.38772010803223 28.46014976501465 28.46014976501465 C 31.38772010803223 25.53258895874023 33 21.64019966125488 33 17.5 C 33 13.35980033874512 31.38772010803223 9.467409133911133 28.46014976501465 6.539850234985352 C 25.53258895874023 3.612279891967773 21.64019966125488 2 17.5 2 M 17.5 0 C 27.16497993469238 0 35 7.835020065307617 35 17.5 C 35 27.16497993469238 27.16497993469238 35 17.5 35 C 7.835020065307617 35 0 27.16497993469238 0 17.5 C 0 7.835020065307617 7.835020065307617 0 17.5 0 Z", stroke: "none", fill: "#fff" })] }), _jsx("path", { id: "Path-3", "data-name": "Path", d: "M3.492,12.156a1.475,1.475,0,0,1-1.471-1.473V3a1.472,1.472,0,0,1,2.13-1.316l7.68,3.84a1.472,1.472,0,0,1,0,2.633L4.151,12a1.475,1.475,0,0,1-.659.157m0-9.829A.677.677,0,0,0,2.82,3v7.681a.672.672,0,0,0,.973.6l7.68-3.84a.673.673,0,0,0,0-1.2L3.793,2.4a.669.669,0,0,0-.3-.073", transform: "translate(15.791 14.658)", fill: "#fff", stroke: "#fff", strokeWidth: "1" })] }) })), _jsx("video", { ref: refVideo, controls: controls || false, id: "video1detaisl", playsInline: true, poster: isDesktop ? poster : '', className: classExtra, children: _jsx("source", { "data-src": src, type: "video/mp4" }) })] });
};
